var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.news.id)?_c('div',{staticClass:"jr-h5-details"},[_c('p',{ref:"jrDetailContent",staticClass:"news-content",domProps:{"innerHTML":_vm._s(_vm.news.content)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }